<template>
  <div class="faq-list">
    <collapse
      v-for="({question, answer}, idx) in questions"
      :key="idx"
      ref="collapse"
      :content="answer"
      :is-collapsed="idx !== currentIdx"
      :title="question"
      class="faq-list_item"
      @collapse="onCollapse($event, idx)"
    />
  </div>
</template>
<script>
import Collapse from './Collapse.vue';

export default {
  name: 'FaqList',
  components: {
    Collapse,
  },
  props: {
    questions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      currentIdx: '',
    };
  },
  methods: {
    onCollapse(element, idx) {
      if (idx === this.currentIdx) {
        this.currentIdx = '';
        return;
      }
      this.currentIdx = idx;
      this.$nextTick(() => {
        setTimeout(() => {
          this.scrollToElement(this.$refs['collapse'][idx].$el);
        }, 400);
      });
    },
    scrollToElement(el) {
      let offsetY = window.innerWidth <= 999 ? 15 : 100;
      let top = el.getBoundingClientRect().top + window.pageYOffset - offsetY;
      window.scrollTo({top, behavior: 'smooth'});
    },
  },
};
</script>
<style scoped>
.faq-list_item {
  margin-bottom: 30px;
}
</style>
